import React from "react";

import { Grid } from "@material-ui/core";

import Day from "./day";

export default function Schedule({ place, disable }) {


  const dayNames = ["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado"]

  const [copiedRanges, setCopiedRanges] = React.useState(null);

  const copyRanges = (ranges) => {
    setCopiedRanges(ranges)
  }

  return (
    <Grid container spacing={2} >
      { place.baseSchedule.days.map((day,index) => (
          <Grid key={index} item xs={12}>
            <Day name={dayNames[index]} day={day} disable={disable} copyRanges={copyRanges} copiedRanges={copiedRanges} />
          </Grid>
      ))}
    </Grid>
  );
}
